import { PropsWithChildren } from "react";

import * as styles from "./DrawerFooter.css";

export function DrawerFooter({ children }: PropsWithChildren) {
    return (
        <div className={styles.container}>
            <div className={styles.actions}>{children}</div>
        </div>
    );
}
